var _rect, _path, _rect2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDivider(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 202,
    height: 18,
    viewBox: "0 0 202 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 8.51465,
    width: 79.5,
    height: 0.970588,
    fill: "#E7E7E7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M96.9827 13.108C96.1987 13.108 95.5147 12.932 94.9307 12.58C94.3547 12.22 93.9067 11.716 93.5867 11.068C93.2747 10.42 93.1187 9.652 93.1187 8.764C93.1187 7.876 93.2747 7.108 93.5867 6.46C93.8987 5.812 94.3427 5.312 94.9187 4.96C95.5027 4.608 96.1907 4.432 96.9827 4.432C97.7827 4.432 98.4707 4.608 99.0467 4.96C99.6307 5.312 100.079 5.812 100.391 6.46C100.711 7.1 100.871 7.864 100.871 8.752C100.871 9.64 100.711 10.412 100.391 11.068C100.071 11.716 99.6187 12.22 99.0347 12.58C98.4587 12.932 97.7747 13.108 96.9827 13.108ZM96.9827 12.232C97.8867 12.232 98.5867 11.928 99.0827 11.32C99.5787 10.712 99.8267 9.86 99.8267 8.764C99.8267 7.668 99.5787 6.82 99.0827 6.22C98.5867 5.612 97.8867 5.308 96.9827 5.308C96.0947 5.308 95.4027 5.612 94.9067 6.22C94.4107 6.82 94.1627 7.668 94.1627 8.764C94.1627 9.852 94.4107 10.704 94.9067 11.32C95.4027 11.928 96.0947 12.232 96.9827 12.232ZM102.63 13V4.54H105.978C106.89 4.54 107.586 4.752 108.066 5.176C108.554 5.6 108.798 6.204 108.798 6.988C108.798 7.612 108.626 8.124 108.282 8.524C107.946 8.924 107.466 9.184 106.842 9.304C107.21 9.432 107.526 9.744 107.79 10.24L109.278 13H108.198L106.734 10.288C106.55 9.952 106.338 9.724 106.098 9.604C105.858 9.484 105.542 9.424 105.15 9.424H103.614V13H102.63ZM103.614 8.644H105.834C107.162 8.644 107.826 8.092 107.826 6.988C107.826 5.9 107.162 5.356 105.834 5.356H103.614V8.644Z",
    fill: "#6D6D6D"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 122,
    y: 8.51465,
    width: 79.5,
    height: 0.970588,
    fill: "#E7E7E7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDivider);
export default __webpack_public_path__ + "static/media/divider.0adefa73dda9e3f5c9e3f53a5850cfbf.svg";
export { ForwardRef as ReactComponent };